<template>
  <div class="content">
    <LinkPath current-path="consulta origem idn"/>

    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group" style="padding: 10px !important;">

              <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

              <div class="agent-input-group">

                <div class="input-group mb-3">
                  <label class="input-group-text">Digite o Identificador de Registro Biométrico ou o Cadastro de Pessoa Física</label>
                  <input type="text" class="form-control cpf" id="idn" v-model="idn">
                </div>

                <div class="form-group  pesquisa-box">
                  <div class="col-md-1 mb-3">
                    <button id="btnSearchIDN" type="button"
                            v-on:click="searchIDN()"
                            class="btn btn-primary search-button"
                            style="margin-bottom: 5px"
                    >
                      Pesquisar
                    </button>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <BioInfo id="bioInfo" :bio-info-list="bioInfoList"/>
    </section>

  </div>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'
import LinkPath from '../components/LinkPath'
import BioInfo from '../components/BioInfo'

export default {
  components: {BioInfo, LinkPath},
  data: function () {
    return {
      idn: '',
      idnOriginResponse: null,
      bioInfoList: []
    }
  },
  methods: {
    searchIDN() {
      this.clear()
      if (this.idn) {
        $('#btnSearchIDN').attr('disabled', true)

        interceptor.request('POST', 'api/v1/psbio/find/ac', {idnCpf: this.idn})
          .then(response => {
            this.idnOriginResponse = response.data

            if (!this.idnOriginResponse) {
              $('#divAlert').attr('class', 'alert alert-warning')
                .append('<p style="font-weight: bold;">Erro de comunicação</p>')
                .show()
              return
            }

            let infoList = [
              {property: 'IDN:', value: response.data.idn},
              {property: 'Origem:', value: response.data.psbioOwner || 'Origem não encontrada na PSBIO'}
            ]
            const role = window.localStorage.getItem('role')
            const canView = ['ADMIN', 'ANALISE_E_EXCLUSAO_DE_BIOMETRIAS', 'SUPORTE PSS/PSBIO']
            if (canView.includes(role)) {
              infoList.push({property: 'CPF:', value: response.data.cpf || 'CPF não encontrado na base de IDNs'})
            }
            this.bioInfoList.push({
              title: 'Resultado da consulta',
              infoList: infoList
            }, {}, {})
          })
          .catch(error => {
            $('#divAlert').attr('class', 'alert alert-danger')
              .append(`<p style="font-weight: bold;">Erro ao tentar pesquisar as biometrias. Serviço indisponível. ${error}</p>`)
              .show()
          })
          .finally(
            $('#btnSearchIDN').attr('disabled', false)
          )
      }
    },
    clear() {
      $('#divAlert').empty().hide()
      this.bioInfoList = []
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FindIDNOrigin.vue?30cfe8f1